import axios from './api'
const ticketServer = {	
	SearchTask(params) {
		return axios.get(`app/activity/load`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},

	SearchMyTicket(params) {
		return axios.post(`app/coupon/list`, params).then((res) => {
            return res.data
        })
	},

	SearchTicketInfo(params) {
		return axios.get(`app/coupon/load`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},

	Searchprice(params) {
		return axios.get(`app/coupon/useCheck`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},

	GetKuaikeTicket(params) {
		return axios.get(`app/coupon/directCouponUse`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},

	GetTicket(params) {
		return axios.get(`app/coupon/receive`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},

	SearchActivityN(params) {
		return axios.get(`app/activity/queryCouponList`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},
	SearchActivityY(params) {
		return axios.get(`app/activity/loginQueryCouponList`, {params},{
            headers: {
              'Content-Type': 'multipart/x-www-form-urlencoded'
            }
        }).then((res) => {
            return res.data
        })
	},





}

export default ticketServer


// WEBPACK FOOTER //
// ./src/api/ticket.js